module.exports = __webpack_public_path__ + "static/media/sunset.842357a9.svg";